import React from "react";
import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";

const Pagination = ({
    currentPage,
    totalPages,
    onPageChange,
    totalItems,
    itemsPerPage,
    startIndex,
    endIndex,
}) => {
    if (totalPages <= 1) return null;

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                for (let i = 1; i <= 4; i++) {
                    pages.push(i);
                }
                pages.push("ellipsis");
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1);
                pages.push("ellipsis");
                for (let i = totalPages - 3; i <= totalPages; i++) {
                    pages.push(i);
                }
            } else {
                pages.push(1);
                pages.push("ellipsis");
                for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                    pages.push(i);
                }
                pages.push("ellipsis");
                pages.push(totalPages);
            }
        }

        return pages;
    };

    const pageNumbers = getPageNumbers();

    console.log(pageNumbers);

    return (
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-6 py-5 border-t border-gray-100 bg-gray-50/30">
            {/* Results Info */}
            <div className="text-sm text-gray-600">
                Showing{" "}
                <span className="font-semibold text-gray-900">
                    {startIndex + 1}
                </span>{" "}
                to{" "}
                <span className="font-semibold text-gray-900">
                    {Math.min(endIndex, totalItems)}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-900">
                    {totalItems}
                </span>{" "}
                results
            </div>

            {/* Pagination Controls */}
            <div className="flex items-center gap-2">
                {/* Previous Button */}
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                        currentPage === 1
                            ? "text-gray-400 cursor-not-allowed bg-gray-100"
                            : "text-gray-700 hover:bg-white hover:text-primary hover:shadow-sm border border-gray-200"
                    }`}
                >
                    <Iconify
                        icon={IconCode.backArrow}
                        width={16}
                        className={
                            currentPage === 1
                                ? "text-gray-400"
                                : "text-gray-600"
                        }
                    />
                    <span>Previous</span>
                </button>

                {/* Page Numbers */}
                <div className="flex items-center gap-1">
                    {pageNumbers.map((page, index) => {
                        if (page === "ellipsis") {
                            return (
                                <span
                                    key={`ellipsis-${index}`}
                                    className="px-2 text-gray-400"
                                >
                                    ...
                                </span>
                            );
                        }

                        const isActive = page === currentPage;
                        return (
                            <button
                                key={page}
                                onClick={() => onPageChange(page)}
                                className={`min-w-[36px] h-9 px-3 rounded-lg text-sm font-medium transition-all ${
                                    isActive
                                        ? "bg-primary text-white shadow-md hover:shadow-lg"
                                        : "text-gray-700 hover:bg-white hover:text-primary hover:shadow-sm border border-gray-200"
                                }`}
                            >
                                {page}
                            </button>
                        );
                    })}
                </div>

                {/* Next Button */}
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                        currentPage === totalPages
                            ? "text-gray-400 cursor-not-allowed bg-gray-100"
                            : "text-gray-700 hover:bg-white hover:text-primary hover:shadow-sm border border-gray-200"
                    }`}
                >
                    <span>Next</span>
                    <Iconify
                        icon={IconCode.forwardArrow}
                        width={16}
                        className={
                            currentPage === totalPages
                                ? "text-gray-400"
                                : "text-gray-600"
                        }
                    />
                </button>
            </div>
        </div>
    );
};

export default Pagination;
